import { PropTypes } from 'react';

export const IdType = PropTypes.any;

export const DateType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.object
]);

export const AvatarShape = PropTypes.shape({
  id: IdType,
  url: PropTypes.string
});

export const QuestionOptionShape = PropTypes.shape({
  text: PropTypes.text,
  value: PropTypes.node
});

export const QuestionShape = PropTypes.shape({
  id: IdType,
  text: PropTypes.string,
  answer: PropTypes.node,
  options: PropTypes.arrayOf(QuestionOptionShape)
});

export const QuestionnaireShape = PropTypes.shape({
  id: IdType,
  summary: PropTypes.string,
  description: PropTypes.string,
  questions: PropTypes.arrayOf(QuestionShape)
});

export const ChatResourceShape = PropTypes.shape({
  metadata: PropTypes.shape({
    title: PropTypes.string
  }),
  data: PropTypes.shape({
    url: PropTypes.string
  }),
  sender: PropTypes.string,
  sentAt: PropTypes.string
});

export const ChatMessageShape = PropTypes.shape({
  id: IdType,
  fromCounsellor: PropTypes.bool,
  createdAt: DateType,
  text: PropTypes.string
});

export const ChatDocumentShape = PropTypes.shape({
  id: IdType,
  name: PropTypes.string,
  url: PropTypes.string
});

export const ChatWebsiteShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string
});

export const GoalShape = PropTypes.shape({
  id: IdType,
  goal: PropTypes.string,
  score: PropTypes.number
});

export const ChatItemShape = PropTypes.shape({
  chatDocuemnt: ChatDocumentShape,
  chatWebsite: ChatWebsiteShape,
  chatQuestionnaire: QuestionnaireShape,
  goals: PropTypes.arrayOf(GoalShape)
});

export const MailThreadMessageShape = PropTypes.shape({
  id: IdType,
  read: PropTypes.bool,
  fromCounsellor: PropTypes.fromCounsellor,
  createdAt: DateType,
  sender: PropTypes.string,
  avatar: AvatarShape
});

export const MailThreadShape = PropTypes.shape({
  id: IdType,
  latestMessage: MailThreadMessageShape,
  participant: PropTypes.string,
  avatar: AvatarShape
});

export const ThumbnailResolutionShape = PropTypes.shape({
  highRes: PropTypes.string,
  lowRes: PropTypes.string
});

export const ThumbnailShape = PropTypes.shape({
  preview: ThumbnailResolutionShape,
  main: ThumbnailResolutionShape
});

export const AuthorShape = PropTypes.shape({
  avatar: PropTypes.shape({
    url: PropTypes.string,
    id: IdType
  }),
  userName: PropTypes.string
});

export const TopicShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  resourceCount: PropTypes.number,
  userCount: PropTypes.number
});

export const CategoryThumbnailShape = PropTypes.shape({
  url: PropTypes.string
});

export const CategoryShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  thumbnail: CategoryThumbnailShape,
  resourceCount: PropTypes.number,
  userCount: PropTypes.number
});

export const MagazineArticleShape = PropTypes.shape({
  id: IdType,
  commentCount: PropTypes.number,
  createdAt: DateType,
  summary: PropTypes.string,
  thumbnail: ThumbnailShape,
  title: PropTypes.string,
  topics: PropTypes.arrayOf(TopicShape),
  author: AuthorShape,
  text: PropTypes.string,
  favourite: PropTypes.bool
});

export const CommentShape = PropTypes.shape({
  id: IdType,
  text: PropTypes.string,
  useful: PropTypes.bool,
  resourceId: IdType,
  resourceType: PropTypes.string,
  replyCount: PropTypes.number,
  createdAt: DateType
});

export const JournalEmojiShape = PropTypes.shape({
  emoji: PropTypes.string
});

export const JournalEntryShape = PropTypes.shape({
  id: IdType,
  emoji: PropTypes.string,
  text: PropTypes.string,
  createdAt: DateType
});

export const ReferralLocationShape = PropTypes.shape({
  id: IdType,
  location: PropTypes.string
});

export const ReferralSchoolShape = PropTypes.shape({
  id: IdType,
  school: PropTypes.string
});

export const ReferralLanguageShape = PropTypes.shape({
  id: IdType,
  location: PropTypes.string
});

export const ReferralProvider = PropTypes.shape({
  id: IdType,
  name: PropTypes.string,
  logo: PropTypes.string,
  description: PropTypes.string
});

export const FeedItemShape = PropTypes.shape({
  feedChat: FeedButtonShape,
  feedInterests: FeedButtonShape,
  feedJournal: FeedJournalShape,
  feedGoals: FeedGoalsShape,
  feedQuestionnaire: QuestionnaireShape,
  magazineArticle: MagazineArticleShape
});

export const FeedButtonShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  text: PropTypes.string,
  button: PropTypes.string
});

export const FeedJournalShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  text: PropTypes.string,
  emojis: PropTypes.arrayOf(JournalEmojiShape)
});

export const FeedGoalsShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  goals: PropTypes.arrayOf(GoalShape)
});

export const SearchItemShape = PropTypes.shape({
  article: MagazineArticleShape,
  comment: CommentShape
});

export const LinkShape = PropTypes.shape({
  image: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string
});

export const ForumThreadShape = PropTypes.shape({
  id: IdType,
  title: PropTypes.string,
  body: PropTypes.string,
  author: AuthorShape,
  commentCount: PropTypes.number
});



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/entities.js
 **/